import { FC } from "react"

/** Components */
import { tContext } from "../types"
import styled from "styled-components"
import { colorAttentionBlue10, colorAttentionBlue50, fontSizeS } from "@rhumbix/rmbx_design_system_web"

/** Types */
type Props = {
    data: Record<string, any>
    config: Record<string, any>
    context: tContext
}

const DownloadExportsButtonCellRenderer: FC<Props> = props => {
    const startDownload = () => {
        window.open(props.data.output_file)
    }

    return (
        <ActionButton onClick={startDownload} id={props.data.buttonId} type="button" className="action-button" disabled={!props.data.output_file}>
            <div>Download Results</div>
        </ActionButton>
    )
}

export default DownloadExportsButtonCellRenderer

const ActionButton = styled.button<{ longerButton?: boolean }>`
    background-color: ${colorAttentionBlue10};
    color: ${colorAttentionBlue50};
    font-weight: 500;
    font-size: ${fontSizeS};
    line-height: 16px;
    pointer-events: auto;
    min-width: 30px;
    height: 32px;
    text-align: center;
    padding: 8px;
    border: 0px;
    width: auto;
    border-radius: 2px;
}
`
